import { render, staticRenderFns } from "./OperatorsAPI.vue?vue&type=template&id=f4670a8c&scoped=true&"
import script from "./OperatorsAPI.vue?vue&type=script&lang=js&"
export * from "./OperatorsAPI.vue?vue&type=script&lang=js&"
import style0 from "./OperatorsAPI.vue?vue&type=style&index=0&id=f4670a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4670a8c",
  null
  
)

export default component.exports